import React, { createContext, useContext, useState, useCallback } from 'react';
import MessageModal from '../components/MessageModal';
import PopupModal from '../components/PopupModal';
import useUnreadMessageCount from '../hooks/useUnreadMessageCount';

const MessageContext = createContext(null);

export function MessageProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('inbox');
  const [recipient, setRecipient] = useState(null);
  const { count: unreadCount, refresh: refreshUnread } = useUnreadMessageCount();

  const openInbox = useCallback(() => {
    setMode('inbox');
    setRecipient(null);
    setOpen(true);
  }, []);

  const openCompose = useCallback((rec) => {
    setMode('compose');
    setRecipient(rec);
    setOpen(true);
  }, []);

  return (
    <MessageContext.Provider value={{ unreadCount, refreshUnread, openInbox, openCompose }}>
      {children}
      <MessageModal
        open={open}
        onClose={() => setOpen(false)}
        initialMode={mode}
        initialRecipient={recipient}
        onSent={refreshUnread}
      />
      <PopupModal />
    </MessageContext.Provider>
  );
}

export function useMessage() {
  return useContext(MessageContext);
}
